import { imageNames } from "@/src/constants/imageConstants.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";

export const listsHeaders = [
  { label: "List Name", key: "list_name", width: 4, suffix: true },
  { label: "Object", key: "entity_type", width: 2 },
  { label: "Size", key: "list_size", width: 2 },
  { label: "Created by", key: "created_by", width: 2, view: true },
  { label: "Last updated", key: "updated_on", width: 2 },
];

export const listAccessTypes = {
  ANYONE: "ANYONE",
  PRIVATE: "PRIVATE",
};

export const entitySelectorOptions = [
  {
    id: entityTypes.CONTACT,
    title: "Contacts",
    description: "Create a list of contacts",
    icon: imageNames.CONTACTS_GREY,
  },
  {
    id: entityTypes.COMPANY,
    title: "Companies",
    description: "Create a list of companies",
    icon: imageNames.COMPANIES_GREY,
  },
  {
    id: entityTypes.LEAD,
    title: "Leads",
    description: "Create a list of leads",
    icon: imageNames.LEADS_GREY,
  },
];

export const listAccessSelectorOptions = [
  {
    id: listAccessTypes.ANYONE,
    title: "Anyone from the team",
    description: "Everybody in your workspace will be able to access this list",
    icon: imageNames.ACCESS_FOLDER_GREY,
    alt: "anyone_access_grey_icon",
  },
  {
    id: listAccessTypes.PRIVATE,
    title: "Private",
    description:
      "You and only people you invite will be able to access this list",
    icon: imageNames.LOCK_GREY,
    alt: "private_grey_icon",
  },
];

export const entityContactHeaders = [
  { label: "Name", key: "name", width: 2, avatar: "profile_pic", suffix: true },
  { label: "Contact Score", key: "score", width: 2 },
  { label: "Email", key: "email", width: 2 },
  { label: "Phone Number", key: "phone_number", width: 2 },
  {
    label: "Current Company",
    key: "current_company",
    width: 2,
    avatar: "logo_url",
    view: true,
  },
  { label: "Contact Location", key: "location", width: 2 },
  { label: "Company HQ Location", key: "company_location", width: 2 },
  { label: "Current Role", key: "current_role", width: 2 },
  { label: "Contact Owner", key: "owner", width: 2, view: true },
  { label: "Contact Status", key: "contact_status", width: 2 },
  { label: "Last Activity", key: "last_activity", width: 2 },
];

export const entityCompanyHeaders = [
  {
    label: "Company Name",
    key: "name",
    width: 3,
    avatar: "logo_url",
    suffix: true,
  },
  { label: "Company Score", key: "score", width: 2 },
  { label: "Company Owner", key: "owner", width: 3, view: true },
  { label: "Industry", key: "industry", width: 2 },
  { label: "Country/Region", key: "country", width: 2 },
  { label: "Tags", key: "tags", width: 2 },
];

export const entityLeadHeaders = [
  { label: "Name", key: "name", width: 2, avatar: "profile_pic", suffix: true },
  { label: "Email", key: "email", width: 2 },
  { label: "Phone Number", key: "phone_number", width: 2 },
  {
    label: "Current Company",
    key: "current_company",
    width: 2,
    avatar: "logo_url",
    view: true,
  },
  { label: "Lead Location", key: "location", width: 2 },
  { label: "Company HQ Location", key: "company_location", width: 2 },
  { label: "Current Role", key: "current_role", width: 2 },
  { label: "Lead Owner", key: "owner", width: 2, view: true },
  { label: "Lead Status", key: "lead_status", width: 2 },
  { label: "Lead Score", key: "score", width: 2 },
  { label: "Last Activity", key: "last_activity", width: 2 },
];

export const entityListItems = {
  CONTACT: "contact",
  COMPANY: "company",
  LEAD: "lead",
};

export const LIST_TABS = {
  ALL: "All",
  MY_LISTS: "My Lists",
};
